'use strict';

var cov_mo5auuive = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/NucleoManager/lib/Localizer.js',
      hash = '7ef39121d10718439c12e2041a3559128a9a143d',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/NucleoManager/lib/Localizer.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 32
        },
        end: {
          line: 2,
          column: 34
        }
      },
      '1': {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 1,
          column: 46
        }
      },
      '2': {
        start: {
          line: 1,
          column: 57
        },
        end: {
          line: 2,
          column: 34
        }
      },
      '3': {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 34
        }
      },
      '4': {
        start: {
          line: 4,
          column: 31
        },
        end: {
          line: 48,
          column: 1
        }
      },
      '5': {
        start: {
          line: 7,
          column: 22
        },
        end: {
          line: 29,
          column: 3
        }
      },
      '6': {
        start: {
          line: 7,
          column: 34
        },
        end: {
          line: 29,
          column: 3
        }
      },
      '7': {
        start: {
          line: 9,
          column: 26
        },
        end: {
          line: 9,
          column: 48
        }
      },
      '8': {
        start: {
          line: 9,
          column: 32
        },
        end: {
          line: 9,
          column: 48
        }
      },
      '9': {
        start: {
          line: 11,
          column: 26
        },
        end: {
          line: 27,
          column: 5
        }
      },
      '10': {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 23,
          column: 7
        }
      },
      '11': {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 17,
          column: 10
        }
      },
      '12': {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 22,
          column: 10
        }
      },
      '13': {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 28
        }
      },
      '14': {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 29
        }
      },
      '15': {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 50
        }
      },
      '16': {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 46,
          column: 5
        }
      },
      '17': {
        start: {
          line: 31,
          column: 17
        },
        end: {
          line: 31,
          column: 36
        }
      },
      '18': {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 45,
          column: 5
        }
      },
      '19': {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 41,
          column: 7
        }
      },
      '20': {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 74
        }
      },
      '21': {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 79
        }
      },
      '22': {
        start: {
          line: 40,
          column: 43
        },
        end: {
          line: 40,
          column: 78
        }
      },
      '23': {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 56
        }
      },
      '24': {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 47,
          column: 17
        }
      },
      '25': {
        start: {
          line: 50,
          column: 23
        },
        end: {
          line: 50,
          column: 52
        }
      },
      '26': {
        start: {
          line: 50,
          column: 31
        },
        end: {
          line: 50,
          column: 52
        }
      },
      '27': {
        start: {
          line: 53,
          column: 31
        },
        end: {
          line: 73,
          column: 1
        }
      },
      '28': {
        start: {
          line: 53,
          column: 50
        },
        end: {
          line: 73,
          column: 1
        }
      },
      '29': {
        start: {
          line: 54,
          column: 24
        },
        end: {
          line: 54,
          column: 50
        }
      },
      '30': {
        start: {
          line: 56,
          column: 25
        },
        end: {
          line: 56,
          column: 61
        }
      },
      '31': {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 60,
          column: 3
        }
      },
      '32': {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 42
        }
      },
      '33': {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 70,
          column: 3
        }
      },
      '34': {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 68,
          column: 62
        }
      },
      '35': {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 37
        }
      },
      '36': {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 72,
          column: 37
        }
      },
      '37': {
        start: {
          line: 75,
          column: 32
        },
        end: {
          line: 81,
          column: 1
        }
      },
      '38': {
        start: {
          line: 76,
          column: 22
        },
        end: {
          line: 76,
          column: 24
        }
      },
      '39': {
        start: {
          line: 77,
          column: 2
        },
        end: {
          line: 79,
          column: 5
        }
      },
      '40': {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 60
        }
      },
      '41': {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 80,
          column: 21
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 32
          },
          end: {
            line: 1,
            column: 33
          }
        },
        loc: {
          start: {
            line: 1,
            column: 57
          },
          end: {
            line: 2,
            column: 34
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 1,
            column: 40
          },
          end: {
            line: 1,
            column: 41
          }
        },
        loc: {
          start: {
            line: 1,
            column: 45
          },
          end: {
            line: 1,
            column: 46
          }
        },
        line: 1
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 1,
            column: 57
          },
          end: {
            line: 1,
            column: 58
          }
        },
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 34
          }
        },
        line: 2
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 4,
            column: 31
          },
          end: {
            line: 4,
            column: 32
          }
        },
        loc: {
          start: {
            line: 4,
            column: 50
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 4
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 7,
            column: 22
          },
          end: {
            line: 7,
            column: 23
          }
        },
        loc: {
          start: {
            line: 7,
            column: 34
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 7
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 7,
            column: 34
          },
          end: {
            line: 7,
            column: 35
          }
        },
        loc: {
          start: {
            line: 7,
            column: 58
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 7
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 9,
            column: 26
          },
          end: {
            line: 9,
            column: 27
          }
        },
        loc: {
          start: {
            line: 9,
            column: 32
          },
          end: {
            line: 9,
            column: 48
          }
        },
        line: 9
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 11,
            column: 26
          },
          end: {
            line: 11,
            column: 27
          }
        },
        loc: {
          start: {
            line: 11,
            column: 36
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 11
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 30,
            column: 31
          },
          end: {
            line: 30,
            column: 32
          }
        },
        loc: {
          start: {
            line: 30,
            column: 45
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 30
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 40,
            column: 30
          },
          end: {
            line: 40,
            column: 31
          }
        },
        loc: {
          start: {
            line: 40,
            column: 43
          },
          end: {
            line: 40,
            column: 78
          }
        },
        line: 40
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 50,
            column: 23
          },
          end: {
            line: 50,
            column: 24
          }
        },
        loc: {
          start: {
            line: 50,
            column: 31
          },
          end: {
            line: 50,
            column: 52
          }
        },
        line: 50
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 53,
            column: 31
          },
          end: {
            line: 53,
            column: 32
          }
        },
        loc: {
          start: {
            line: 53,
            column: 50
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 53
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 53,
            column: 50
          },
          end: {
            line: 53,
            column: 51
          }
        },
        loc: {
          start: {
            line: 53,
            column: 69
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 53
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 33
          }
        },
        loc: {
          start: {
            line: 75,
            column: 52
          },
          end: {
            line: 81,
            column: 1
          }
        },
        line: 75
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 77,
            column: 32
          },
          end: {
            line: 77,
            column: 33
          }
        },
        loc: {
          start: {
            line: 77,
            column: 39
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 77
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 1,
            column: 33
          },
          end: {
            line: 1,
            column: 46
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 1,
            column: 40
          },
          end: {
            line: 1,
            column: 46
          }
        }],
        line: 1
      },
      '1': {
        loc: {
          start: {
            line: 1,
            column: 58
          },
          end: {
            line: 1,
            column: 68
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 1,
            column: 66
          },
          end: {
            line: 1,
            column: 68
          }
        }],
        line: 1
      },
      '2': {
        loc: {
          start: {
            line: 2,
            column: 7
          },
          end: {
            line: 2,
            column: 33
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 2,
            column: 14
          },
          end: {
            line: 2,
            column: 25
          }
        }, {
          start: {
            line: 2,
            column: 28
          },
          end: {
            line: 2,
            column: 33
          }
        }],
        line: 2
      },
      '3': {
        loc: {
          start: {
            line: 13,
            column: 6
          },
          end: {
            line: 23,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 13,
            column: 6
          },
          end: {
            line: 23,
            column: 7
          }
        }, {
          start: {
            line: 13,
            column: 6
          },
          end: {
            line: 23,
            column: 7
          }
        }],
        line: 13
      },
      '4': {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        }],
        line: 32
      },
      '5': {
        loc: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }],
        line: 34
      },
      '6': {
        loc: {
          start: {
            line: 54,
            column: 24
          },
          end: {
            line: 54,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 54,
            column: 24
          },
          end: {
            line: 54,
            column: 44
          }
        }, {
          start: {
            line: 54,
            column: 48
          },
          end: {
            line: 54,
            column: 50
          }
        }],
        line: 54
      },
      '7': {
        loc: {
          start: {
            line: 56,
            column: 25
          },
          end: {
            line: 56,
            column: 61
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 56,
            column: 25
          },
          end: {
            line: 56,
            column: 51
          }
        }, {
          start: {
            line: 56,
            column: 55
          },
          end: {
            line: 56,
            column: 61
          }
        }],
        line: 56
      },
      '8': {
        loc: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        }, {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        }],
        line: 58
      },
      '9': {
        loc: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 75
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 36
          }
        }, {
          start: {
            line: 58,
            column: 40
          },
          end: {
            line: 58,
            column: 75
          }
        }],
        line: 58
      },
      '10': {
        loc: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        }, {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        }],
        line: 62
      },
      '11': {
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 68,
            column: 62
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 66,
            column: 26
          }
        }, {
          start: {
            line: 68,
            column: 10
          },
          end: {
            line: 68,
            column: 62
          }
        }],
        line: 64
      },
      '12': {
        loc: {
          start: {
            line: 72,
            column: 9
          },
          end: {
            line: 72,
            column: 36
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 72,
            column: 9
          },
          end: {
            line: 72,
            column: 14
          }
        }, {
          start: {
            line: 72,
            column: 18
          },
          end: {
            line: 72,
            column: 36
          }
        }],
        line: 72
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0
    },
    b: {
      '0': [0],
      '1': [0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localizeReducers = exports.localizeReducer = exports.localizeActions = exports.localizeGetState = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cov_mo5auuive.s[0]++;
var localizeGetState = exports.localizeGetState = function localizeGetState() {
  var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_mo5auuive.b[0][0]++, function (a) {
    cov_mo5auuive.f[1]++;
    cov_mo5auuive.s[1]++;
    return a;
  });
  var name = arguments[1];
  cov_mo5auuive.f[0]++;
  cov_mo5auuive.s[2]++;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_mo5auuive.b[1][0]++, {});
    cov_mo5auuive.f[2]++;
    cov_mo5auuive.s[3]++;
    return func(name ? (cov_mo5auuive.b[2][0]++, state[name]) : (cov_mo5auuive.b[2][1]++, state));
  };
};

cov_mo5auuive.s[4]++;
var localizeActions = exports.localizeActions = function localizeActions(actions, name) {
  cov_mo5auuive.f[3]++;
  cov_mo5auuive.s[5]++;

  // create the wrappingAction
  // take the actionFn as parameter and return a new action taking another localized dispatch and getState functions
  var wrappAction = function wrappAction(actionFn) {
    cov_mo5auuive.f[4]++;
    cov_mo5auuive.s[6]++;
    return function (dispatch, getState) {
      cov_mo5auuive.f[5]++;
      cov_mo5auuive.s[7]++;

      // getState should return the local state of the reducer concerned by the action
      var localGetState = function localGetState() {
        cov_mo5auuive.f[6]++;
        cov_mo5auuive.s[8]++;
        return getState()[name];
      };
      // localDispatch modify the action to ensure that the action is not launched by under reducer
      cov_mo5auuive.s[9]++;
      var localDispatch = function localDispatch(action) {
        cov_mo5auuive.f[7]++;

        var localAction = void 0;
        cov_mo5auuive.s[10]++;
        if (action.stxLocalNames) {
          cov_mo5auuive.b[3][0]++;
          cov_mo5auuive.s[11]++;

          localAction = {
            type: 'stxLocalNames',
            stxLocalNames: [name].concat((0, _toConsumableArray3.default)(action.stxLocalNames))
          };
        } else {
          cov_mo5auuive.b[3][1]++;
          cov_mo5auuive.s[12]++;

          localAction = {
            type: 'stxLocalNames',
            stxLocalNames: [name, action]
          };
        }
        cov_mo5auuive.s[13]++;
        dispatch(localAction);

        cov_mo5auuive.s[14]++;
        return localGetState();
      };
      cov_mo5auuive.s[15]++;
      return actionFn(localDispatch, localGetState);
    };
  };
  cov_mo5auuive.s[16]++;
  (0, _keys2.default)(actions).forEach(function (actionName) {
    cov_mo5auuive.f[8]++;

    var func = (cov_mo5auuive.s[17]++, actions[actionName]);
    cov_mo5auuive.s[18]++;
    if (func instanceof Function) {
      cov_mo5auuive.b[4][0]++;
      cov_mo5auuive.s[19]++;

      // it is not an action to dispatch, but only to get the state independently of the context
      if (actionName === 'getLocalState') {
        cov_mo5auuive.b[5][0]++;
        cov_mo5auuive.s[20]++;

        // eslint-disable-next-line no-param-reassign
        actions[actionName] = localizeGetState(actions[actionName], name);
      } else {
        cov_mo5auuive.b[5][1]++;
        cov_mo5auuive.s[21]++;

        // if it is a common action definedin the actions, wrapp to adapt dispatch and getState inside the action
        // eslint-disable-next-line no-param-reassign
        actions[actionName] = function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          cov_mo5auuive.f[9]++;
          cov_mo5auuive.s[22]++;
          return wrappAction(func.apply(undefined, args));
        };
      }
    } else {
      cov_mo5auuive.b[4][1]++;
      cov_mo5auuive.s[23]++;

      // eslint-disable-next-line no-param-reassign
      actions[actionName] = localizeActions(func, name);
    }
  });
  cov_mo5auuive.s[24]++;
  return actions;
};

cov_mo5auuive.s[25]++;
var isGlobalAction = function isGlobalAction(type) {
  cov_mo5auuive.f[10]++;
  cov_mo5auuive.s[26]++;
  return (/^GLOBAL_/.test(type)
  );
};

// localize the reducer to ensure only action on the right path is launched
cov_mo5auuive.s[27]++;
var localizeReducer = exports.localizeReducer = function localizeReducer(reducer, name) {
  cov_mo5auuive.f[11]++;
  cov_mo5auuive.s[28]++;
  return function (state, action) {
    cov_mo5auuive.f[12]++;

    var stxLocalNames = (cov_mo5auuive.s[29]++, (cov_mo5auuive.b[6][0]++, action.stxLocalNames) || (cov_mo5auuive.b[6][1]++, []));
    // if the action has been localized, take the orignalAction, if no take the direct action
    var originalAction = (cov_mo5auuive.s[30]++, (cov_mo5auuive.b[7][0]++, stxLocalNames.slice(-1)[0]) || (cov_mo5auuive.b[7][1]++, action));
    // action to initialize or prefixed by GLOBAL are called everywhere
    cov_mo5auuive.s[31]++;
    if ((cov_mo5auuive.b[9][0]++, action.type === '@@redux/INIT') || (cov_mo5auuive.b[9][1]++, isGlobalAction(originalAction.type))) {
      cov_mo5auuive.b[8][0]++;
      cov_mo5auuive.s[32]++;

      return reducer(state, originalAction);
    } else {
      cov_mo5auuive.b[8][1]++;
    }
    // if the name is found, return the reducer function
    cov_mo5auuive.s[33]++;
    if (stxLocalNames[0] === name) {
      cov_mo5auuive.b[10][0]++;

      var curAction = (cov_mo5auuive.s[34]++, stxLocalNames.length === 2 ? ( // if it is the last step, use the orginal action in the last element of the array
      cov_mo5auuive.b[11][0]++, stxLocalNames[1]) : ( // if there is still some other step (isolation) return a duplicate of the action and remove the current step
      cov_mo5auuive.b[11][1]++, (0, _extends3.default)({}, action, { stxLocalNames: stxLocalNames.slice(1) })));
      cov_mo5auuive.s[35]++;
      return reducer(state, curAction);
    } else {
      cov_mo5auuive.b[10][1]++;
    }
    // in all the other cases return the state itself, or get the initial state
    cov_mo5auuive.s[36]++;
    return (cov_mo5auuive.b[12][0]++, state) || (cov_mo5auuive.b[12][1]++, reducer(state, {})); // passed empty action to get the current state or default state
  };
};

cov_mo5auuive.s[37]++;
var localizeReducers = exports.localizeReducers = function localizeReducers(reducers, name) {
  cov_mo5auuive.f[13]++;

  var newReducers = (cov_mo5auuive.s[38]++, {});
  cov_mo5auuive.s[39]++;
  (0, _keys2.default)(reducers).forEach(function (key) {
    cov_mo5auuive.f[14]++;
    cov_mo5auuive.s[40]++;

    newReducers[key] = localizeReducer(reducers[key], name);
  });
  cov_mo5auuive.s[41]++;
  return newReducers;
};